import { RoundWizard } from "@client/components/wizard/RoundWizard";

export function Onboarding({ isSfcAdmin }: { isSfcAdmin: boolean }) {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto w-full max-w-3xl py-12 px-4 md:px-8 flex flex-col gap-8">
        <div className="text-center flex flex-col gap-2">
          <h1 className="text-3xl font-bold">Welcome to S-Process</h1>
          <p className="text-lg text-muted-foreground">
            Let's get you set up in just a few steps
          </p>
        </div>
        <RoundWizard isSfcAdmin={isSfcAdmin} />
      </div>
    </div>
  );
}
